import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TestRegexForField, calculeAgeFromDateString } from '../../engine/Rules'
import store from '../../engine/store'
import { InfoBulle } from '../ImportAll'
import './Bloc.css'
import InputMask from 'react-input-mask';

class BlocTextField extends Component {
    constructor(props) {
        super(props)
        this.handleUpdateTextField = this.handleUpdateTextField.bind(this)
    }

    handleUpdateTextField(key, value) {
        var valueToSave = value
        if (this.props.removeEspace) {
            valueToSave = valueToSave.replace(' ', '')
        }
        if (this.props.checkedByRegex) {
            const re = this.props.checkedByRegex
            const valuePreformed = String(valueToSave)
                .toLowerCase()
                .replace(' ', '')

            var regexOK = TestRegexForField(key, valuePreformed, re)

            if (regexOK && this.props.verificationAge18a80Ans) {
                var age = calculeAgeFromDateString(valuePreformed)
                if (age >= 18 && age <= 80) {
                } else {
                    store.dispatch({
                        type: 'SET',
                        value: { key: key + '_validated', value: false },
                    })
                }
            }

            store.dispatch({
                type: 'SET',
                value: { key: key, value: valuePreformed },
            })
        } else {
            store.dispatch({
                type: 'SET',
                value: { key: key, value: valueToSave },
            })
        }
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'
        style.minHeight = '122px'

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        const styleInput = {}
        let erreur = <div></div>
        if (this.props.validated === false) {
            styleInput.backgroundColor = 'rgb(243 238 238)'
            if (this.props.messageErreur) {
                erreur = (
                    <div className="erreurTextFormat">
                        {this.props.messageErreur}
                    </div>
                )
            }
        } else if (this.props.validated === true) {
            styleInput.backgroundColor = 'rgb(230 243 240)'
        }

        var value = this.props.targetDataValue
        let premadeContent = (
            <div>
                <div className="labelfield">{this.props.label}</div>
                <InputMask
                    style={styleInput}
                    className="field bold-font"
                    placeholder={this.props.placeholder}
                    value={value || ''}
                    type={this.props.keyboardNumber ? 'number' : 'text'}
                    onChange={(e) =>
                        this.handleUpdateTextField(
                            this.props.linked_data_id,
                            e.target.value
                        )
                    }
                    mask={this.props.autoCompletionDate ? "99/99/9999" : ""}
                />
                {erreur}
            </div>
        )

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
        validated: state.answer[ownProps.linked_data_id + '_validated'],
    }
}

export default connect(mapStateToProps)(BlocTextField)
